var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "commentMain" }, [
    _c("div", { staticStyle: { display: "flex", "align-items": "center" } }, [
      _vm.wxAvatar
        ? _c("img", { staticClass: "userAvatar", attrs: { src: _vm.wxAvatar } })
        : _c("div", { staticClass: "userAvatar" }),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _vm._v(
          "\n            用户" +
            _vm._s(_vm.evaluationUserPetName) +
            "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "horizonGully" }),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "flex" } }, [
      _c("div", { staticStyle: { "flex-shrink": "0" } }, [
        _vm._v(
          "\n            " + _vm._s(_vm.evaluationOfGoodsTime) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "verticalGully" }),
      _vm._v(" "),
      _c("div", { staticStyle: { "flex-grow": "1", overflow: "auto" } }, [
        _vm._v("\n            规格" + _vm._s(_vm.productName) + "\n        ")
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.evaluationOfGoodsMsg && _vm.evaluationOfGoodsMsg.length,
          expression: "evaluationOfGoodsMsg && evaluationOfGoodsMsg.length"
        }
      ],
      staticClass: "horizonGully"
    }),
    _vm._v(" "),
    _c("div", [
      _vm._v("\n        " + _vm._s(_vm.evaluationOfGoodsMsg) + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }